import { useQuery, type ApolloError } from '@apollo/react-hooks';
import gql from 'graphql-tag';
import { type FundingIndicators } from './types';
import { type FundingSourceConfiguration } from '../../../Nomination/components';
import { type ProgrammeChoiceMetadata } from '../../../Application/graphql';

type GetfundingSourceConfiguration = {
  fundingSourceConfiguration: FundingSourceConfiguration;
  fundingIndicators: FundingIndicators;
  programmeChoiceMetadata: ProgrammeChoiceMetadata;
  loading: boolean;
  error: ApolloError | undefined;
};

export const useGetFundingConfig = (): GetfundingSourceConfiguration => {
  const { data, loading, error } = useQuery(
    gql`
      query {
        getFundingSourceConfiguration {
          mapping
          fundingIndicators
        }

        programmeChoiceMetadata {
          departments {
            value
            label
          }
          entryYears
          entryYearList {
            value
            label
          }
        }
      }
    `,
    {
      fetchPolicy: 'network-only',
    },
  );

  const fundingSourceConfiguration: FundingSourceConfiguration = {
    mapping: {
      COMPETITIVE:
        data?.getFundingSourceConfiguration?.mapping?.COMPETITIVE ?? [],
      NON_COMPETITIVE:
        data?.getFundingSourceConfiguration?.mapping?.NON_COMPETITIVE ?? [],
      OTHER: data?.getFundingSourceConfiguration?.mapping?.OTHER ?? [],
    },
    validTags: [],
  };

  const fundingIndicators: FundingIndicators =
    data?.getFundingSourceConfiguration?.fundingIndicators ?? {};

  const programmeChoiceMetadata: ProgrammeChoiceMetadata =
    data?.programmeChoiceMetadata ?? {
      departments: [],
      entryYears: [],
      entryYearList: [],
      prgCollabPhdPartnerList: [],
      rpgJoinPhdPartnerList: [],
    };

  return {
    fundingSourceConfiguration,
    fundingIndicators,
    programmeChoiceMetadata,
    loading,
    error,
  };
};
